import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../state/consts.ts";

export default function ModalInfoWohnflaeche() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <p>Bitte die Gesamtfläche derjenigen Räume im Haus angeben, die beheizt werden. Beheizte Wohnflächen sind i.d.R. Wohnzimmer, Badezimmer, Küchen, Schlafzimmer usw.. Nebenräume, in denen kein Heizkörper vorhanden ist, zählen nicht dazu, etwa das Treppenhaus, Flure oder Abstellräume.</p>
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

